module.exports = __webpack_public_path__ + "media/images/swifticons/weather-partly-sunny-0d2474463e342b413fa065ca7c0d63bc.svg";